/* ==========================================================================
   Paladiom theme scripts
   Configuration and translated strings are provided by layout/theme.liquid
   through `window.Paladiom`.
   ========================================================================== */
(function () {
  'use strict';

  var config = window.Paladiom || {};
  var strings = config.strings || {};
  var root = config.root || '/';
  var toast = document.querySelector('.toast');
  var toastTimer;

  /* ------------------------------------------------------------------------
     Helpers
     ------------------------------------------------------------------------ */
  function message(text) {
    if (!toast) return;
    toast.textContent = text;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.textContent = '';
    }, 5000);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Format a price in cents using the store's money format ("${{amount}}"). */
  function formatMoney(cents) {
    var format = config.moneyFormat || '${{amount}}';
    var value = (Number(cents) || 0) / 100;

    function withSeparators(number, decimals, thousands, decimal) {
      var parts = number.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }

    var formatted;
    if (format.indexOf('amount_no_decimals_with_comma_separator') !== -1) {
      formatted = withSeparators(value, 0, '.', ',');
    } else if (format.indexOf('amount_no_decimals') !== -1) {
      formatted = withSeparators(value, 0, ',', '.');
    } else if (format.indexOf('amount_with_comma_separator') !== -1) {
      formatted = withSeparators(value, 2, '.', ',');
    } else if (format.indexOf('amount_with_apostrophe_separator') !== -1) {
      formatted = withSeparators(value, 2, "'", '.');
    } else {
      formatted = withSeparators(value, 2, ',', '.');
    }

    return format.replace(/\{\{\s*\w+\s*\}\}/, formatted);
  }

  function request(path, data) {
    var options = {
      method: data ? 'POST' : 'GET',
      headers: { Accept: 'application/json' }
    };
    if (data) {
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(data);
    }
    return fetch(root + path, options).then(function (response) {
      return response.json().then(function (json) {
        if (!response.ok) {
          throw new Error(json.description || json.message || strings.error);
        }
        return json;
      });
    });
  }

  /* ------------------------------------------------------------------------
     Dialogs (search, mobile menu, cart drawer)
     ------------------------------------------------------------------------ */
  function initDialogs() {
    document.querySelectorAll('[data-open]').forEach(function (button) {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', function () {
        var dialog = document.getElementById(button.dataset.open);
        if (dialog && !dialog.open) dialog.showModal();
      });
    });

    document.querySelectorAll('dialog').forEach(function (dialog) {
      if (dialog.dataset.bound) return;
      dialog.dataset.bound = 'true';

      dialog.addEventListener('click', function (event) {
        // Close buttons and any link inside the dialog (delegated so that
        // content rendered later, like the cart lines, also closes it).
        if (event.target.closest('[data-close]') || event.target.closest('a[href]')) {
          dialog.close();
          return;
        }
        // Click on the backdrop.
        if (event.target === dialog) {
          var rect = dialog.getBoundingClientRect();
          var outside =
            event.clientX < rect.left ||
            event.clientX > rect.right ||
            event.clientY < rect.top ||
            event.clientY > rect.bottom;
          if (outside) dialog.close();
        }
      });
    });
  }

  /* ------------------------------------------------------------------------
     Cart drawer
     ------------------------------------------------------------------------ */
  function cartLineHtml(item) {
    var image = item.image
      ? '<img src="' + escapeHtml(item.image) + '" alt="" loading="lazy" width="72" height="72">'
      : '<span aria-hidden="true">' + escapeHtml(item.product_title.charAt(0)) + '</span>';

    return (
      '<div class="cart-line">' +
      '<div class="cart-line-media">' +
      '<div class="cart-line-image">' + image + '</div>' +
      '<div>' +
      '<h3><a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a></h3>' +
      (item.variant_title ? '<p class="cart-note">' + escapeHtml(item.variant_title) + '</p>' : '') +
      '<div class="cart-controls">' +
      '<button type="button" aria-label="' + escapeHtml(strings.decrease) + '" data-key="' + escapeHtml(item.key) + '" data-qty="' + (item.quantity - 1) + '">−</button>' +
      '<span>' + item.quantity + '</span>' +
      '<button type="button" aria-label="' + escapeHtml(strings.increase) + '" data-key="' + escapeHtml(item.key) + '" data-qty="' + (item.quantity + 1) + '">+</button>' +
      '<button type="button" aria-label="' + escapeHtml(strings.remove) + '" data-key="' + escapeHtml(item.key) + '" data-qty="0">×</button>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '<strong>' + formatMoney(item.final_line_price) + '</strong>' +
      '</div>'
    );
  }

  function renderCart(open) {
    return request('cart.js').then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
      });

      var container = document.getElementById('cart-content');
      var dialog = document.getElementById('cart-dialog');
      if (!container || !dialog) return cart;

      if (cart.items.length) {
        container.innerHTML =
          cart.items.map(cartLineHtml).join('') +
          '<div class="cart-total"><span>' + escapeHtml(strings.subtotal) + '</span><strong>' + formatMoney(cart.total_price) + '</strong></div>' +
          '<p class="cart-note">' + escapeHtml(strings.shipping) + '</p>' +
          '<form action="' + root + 'cart" method="post">' +
          '<button class="btn lime full" name="checkout" type="submit">' + escapeHtml(strings.checkout) + ' →</button>' +
          '</form>' +
          '<p class="cart-note" style="text-align:center"><a class="text-link" href="' + root + 'cart">' + escapeHtml(strings.viewBag) + '</a></p>';
      } else {
        container.innerHTML =
          '<div class="empty"><p>' + escapeHtml(strings.empty) + '</p>' +
          '<a class="btn" href="' + root + 'collections/all">' + escapeHtml(strings.shop) + '</a></div>';
      }

      container.querySelectorAll('[data-key]').forEach(function (button) {
        button.addEventListener('click', function () {
          container.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
          request('cart/change.js', { id: button.dataset.key, quantity: Number(button.dataset.qty) })
            .then(function () { return renderCart(false); })
            .catch(function (error) {
              message(error.message);
              container.querySelectorAll('button').forEach(function (b) { b.disabled = false; });
            });
        });
      });

      if (open && !dialog.open) dialog.showModal();
      return cart;
    });
  }

  function initCart() {
    if (!config.cartDrawer) return;

    document.querySelectorAll('[data-cart-open]').forEach(function (link) {
      if (link.dataset.bound) return;
      link.dataset.bound = 'true';
      link.addEventListener('click', function (event) {
        event.preventDefault();
        renderCart(true).catch(function () {
          window.location.href = link.href;
        });
      });
    });
  }

  /* Add-to-bag forms: <form data-product-form> */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('[data-product-form]')) return;
    event.preventDefault();

    var button = form.querySelector('[type=submit]');
    var data = new FormData(form);
    if (button) button.disabled = true;

    request('cart/add.js', {
      items: [{ id: Number(data.get('id')), quantity: Number(data.get('quantity') || 1) }]
    })
      .then(function () {
        if (config.cartDrawer) return renderCart(true);
        return request('cart.js').then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
        });
      })
      .then(function () { message(strings.added); })
      .catch(function (error) { message(error.message); })
      .then(function () { if (button) button.disabled = false; });
  });

  /* ------------------------------------------------------------------------
     Collection sorting
     ------------------------------------------------------------------------ */
  function initSort() {
    document.querySelectorAll('[data-sort]').forEach(function (select) {
      if (select.dataset.bound) return;
      select.dataset.bound = 'true';
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* ------------------------------------------------------------------------
     Product page: variants, quantity, gallery
     ------------------------------------------------------------------------ */
  function initProduct() {
    var select = document.querySelector('[data-variant-select]');
    var dataEl = document.getElementById('variant-data');

    if (select && dataEl && !select.dataset.bound) {
      select.dataset.bound = 'true';
      var variants = JSON.parse(dataEl.textContent);

      select.addEventListener('change', function () {
        var variant = variants.find(function (v) { return String(v.id) === select.value; });
        if (!variant) return;

        var button = select.form.querySelector('[type=submit]');
        button.disabled = !variant.available;
        button.textContent = variant.available ? strings.add : strings.soldOut;

        var price = document.querySelector('[data-product-price]');
        if (price) {
          price.innerHTML =
            formatMoney(variant.price) +
            (variant.compare_at_price > variant.price
              ? '<s>' + formatMoney(variant.compare_at_price) + '</s>'
              : '');
        }

        if (variant.featured_media) showMedia(variant.featured_media.id);

        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      });
    }

    document.querySelectorAll('[data-qty-change]').forEach(function (button) {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', function () {
        var input = button.parentElement.querySelector('input');
        var next = Number(input.value || 1) + Number(button.dataset.qtyChange);
        input.value = Math.max(1, next);
      });
    });

    document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      if (thumb.dataset.bound) return;
      thumb.dataset.bound = 'true';
      thumb.addEventListener('click', function () {
        showMedia(thumb.dataset.thumb);
      });
    });
  }

  function showMedia(mediaId) {
    var found = false;
    document.querySelectorAll('[data-media-id]').forEach(function (media) {
      var active = String(media.dataset.mediaId) === String(mediaId);
      media.hidden = !active;
      if (active) found = true;
    });
    if (!found) return;
    document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.setAttribute('aria-current', String(thumb.dataset.thumb) === String(mediaId));
    });
  }

  /* ------------------------------------------------------------------------
     Customer addresses: confirm before deleting
     ------------------------------------------------------------------------ */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('[data-confirm]')) return;
    if (!window.confirm(form.dataset.confirm)) event.preventDefault();
  });

  /* ------------------------------------------------------------------------
     Init (also re-run when the theme editor reloads a section)
     ------------------------------------------------------------------------ */
  function init() {
    initDialogs();
    initCart();
    initSort();
    initProduct();
  }

  init();
  document.addEventListener('shopify:section:load', init);
})();
